import { useCallback } from 'react';
import type { UseDeepLinkURLReturn } from '../../types';
import { useDeepLinkContext } from './useDeepLinkContext';

export const useDeepLinkURL = (): UseDeepLinkURLReturn => {
    const deepLinkContext = useDeepLinkContext();

    const getDeepLinkURL = useCallback<UseDeepLinkURLReturn['getDeepLinkURL']>(
        (path, overrideStateSlice) => {
            return deepLinkContext.buildDeepLinkURL({ path, overrideStateSlice }) ?? '';
        },
        [deepLinkContext]
    );

    return {
        getDeepLinkURL
    };
};
